"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function getServiceIdentifierName(serviceIdentifier) {
    if (typeof serviceIdentifier === "function") {
        return `class ${serviceIdentifier.name} {}`;
    }
    return serviceIdentifier.toString();
}
exports.default = getServiceIdentifierName;
